export function changeRoute(context, val) {
  let sec = document.querySelector(".section");
  sec.classList.add("out");

  let t = context;
  setTimeout(() => {
    t.$router.push(val);
  }, 1000);
}

export function checkLicense(val) {
  window.config.hasLicense = val;
}

export function checkProg(val) {
  window.config.progIndex = val;
}

export function findPlan(context, choice) {
  //console.log('FINDING');
  let ob = context.list[context.progIndex].payPlan;
  for (var key in ob) {
    if (ob[key].plan == choice) {
      window.config.payPlan = ob[key];
      context.payPlan = ob[key];
      context.plan = context.payPlan.title;
    }
  }
}

export function fixHeight(collection) {
  let heights = [];
  collection.forEach((item) => {
    heights.push(item.clientHeight);
  });
  collection.forEach((item) => {
    item.style.height = Math.max.apply(null, heights) + "px";
  });
}

export function validEmail(email) {
  const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(String(email).toLowerCase());
}